import { getApplicationStateIdentifier } from '@resistdesign/voltra/app/utils';

const LIST_USERS = getApplicationStateIdentifier();
const USER_PROFILE = getApplicationStateIdentifier();
const INTERVIEW_TRANSCRIPT = getApplicationStateIdentifier();

export const ADMIN = getApplicationStateIdentifier({
  LIST_USERS,
  USER_PROFILE,
  INTERVIEW_TRANSCRIPT,
});
